import React from 'react'
import { connect } from 'react-redux'
import { getLockBackground } from '@/store/getters'

const LockBackground = props => {
  return (
    <React.Fragment>
      <div className="lock-background" />
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const lockBackground = getLockBackground( state )
  return {
    lockBackground
  }
}

export default connect( mapStateToProps )( LockBackground )



// WEBPACK FOOTER //
// ./src/components/commons/LockBackground.js